<template>
	<div>
		<div class="form-title">Chọn tài khoản của bạn</div>

		<div ref="overlayConfirmSecure" class="methods choose-user" v-if="this.listAccount.length > 0">
			<a href="javascript:void(0)" v-for="user in this.listAccount" :key="user.AccountID" @click="selectAccount(user)">
				<img src="@/assets/images/user-avt1.png" alt="" />
				<div style="cursor: pointer;">
					<span class="account-name">{{ user.AccountName }}</span>
					<span v-if="user.VerifyType == 1">{{ user.Mobile }}</span>
					<span v-else-if="user.VerifyType == 2">{{ user.Email }}</span>
				</div>
			</a>
			<small class="warning" v-show="showWarning">
				<img src="@/assets/images/warning.png" alt="" />{{ textWarinng }}
			</small>
		</div>
		<div class="methods choose-user" v-else>
			Không có dữ liệu
		</div>

		<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="backStep">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
					fill="#0355CE" />
			</svg>
			Quay lại
		</a>
	</div>
</template>
<script>
import { SecureTypeIDEnum } from "@/enum";
import { useForgotPassStore } from "@/store";
export default {
	data() {
		const forgotPassStore = useForgotPassStore();
		return {
			forgotPassStore,
			listAccount: forgotPassStore.listAccount,
			showWarning: false,
			textWarinng: "Mã xác thực không hợp lệ",
		};
	},
	methods: {
		backStep() {
			this.$router.push({
				name: 'forgotpassusername', params: {}
			});
		},
		selectAccount(user) {
			const forgotPassStore = useForgotPassStore();
			forgotPassStore.selectedAccount = user;
			forgotPassStore.signNextStep = '';
			if (user.VerifyType === 2) {
				forgotPassStore.secureTypeID = SecureTypeIDEnum.OTPEmail;
				let loader = this.$loading.show({
					container: this.$refs.overlayConfirmSecure,
					canCancel: false,
				});
				forgotPassStore.forgotpass(1)
					.then((response) => {
						loader.hide();
						if (response.ResponseCode > 0) {
							forgotPassStore.requestId = response.Data.RequestID;
							forgotPassStore.signNextStep = response.Data.SignNextStep;
							forgotPassStore.secureTypeID = response.Data.SecureTypeID;
							forgotPassStore.secureDataInfo = response.Data.SecureDataInfo;
							this.$router.push({
								name: 'forgotpassconfirmsecure',
								params: {}
							});
							return;
						}
						this.textWarinng = response.Description;
						this.showWarning = true;
						return;
					})
					.catch((error) => {
						loader.hide();
						console.error(error);
						this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
						this.showWarning = true;
						return;
					});
					return;
			};

			this.$router.push({
				name: 'forgotpassselectsecure',
				params: {}
			});
		},
	},
};
</script>
<style scoped>
.methods {
	width: 100%;
	max-width: 370px;
	margin: 50px auto;
}

.methods a {
	display: block;
	width: 100%;
	padding: 10px 20px;
}

.methods a:not(:last-child) {
	border-bottom: 1px dotted #3c3c3c;
}

.methods a img {
	vertical-align: middle;
	margin-right: 10px;
}

.choose-user a {
	display: flex;
	align-items: center;
}

.choose-user a span {
	display: block;
	margin-top: 5px;
}

.choose-user a span.account-name{
	color: #0050cd;
    font-size: 24px;
    font-weight: 600;
}

</style>